const emptyScroll = () => ({ top: 0, left: 0 });

const scrollRootsOf = (doc) => {
  if (!doc) return [];
  return [
    ...new Set(
      [doc.scrollingElement, doc.documentElement, doc.body].filter(Boolean),
    ),
  ];
};

const overflowingRoot = (roots) =>
  roots.find((el) => el.scrollTop > 0) ||
  roots.find((el) => el.scrollHeight > el.clientHeight + 1) ||
  roots[0];

export const shouldKeepIframeScroll = (previousVersionId, nextVersionId) =>
  Boolean(
    previousVersionId && nextVersionId && previousVersionId === nextVersionId,
  );

export const readDocumentScroll = (doc) => {
  const el = overflowingRoot(scrollRootsOf(doc));
  if (!el) return emptyScroll();
  return { top: el.scrollTop || 0, left: el.scrollLeft || 0 };
};

export const writeDocumentScroll = (doc, position) => {
  if (!position) return;
  scrollRootsOf(doc).forEach((el) => {
    el.scrollTop = position.top || 0;
    el.scrollLeft = position.left || 0;
  });
};
